// Hand-rolled SVG sparkline (ROADMAP §1.0: no chart library — the same
// components later render inside the self-contained obituary artifact).

import type { Sample } from '../game/driver.ts';

const W = 560;
const H = 96;
const PAD = 4;
const MAX_POINTS = 280;

/** Evenly thin a series to at most n points, always keeping first and last. */
function thin(samples: Sample[], n: number): Sample[] {
  if (samples.length <= n) return samples;
  const out: Sample[] = [];
  const step = (samples.length - 1) / (n - 1);
  for (let i = 0; i < n; i++) out.push(samples[Math.round(i * step)]!);
  return out;
}

export function Sparkline({ samples }: { samples: Sample[] }) {
  if (samples.length < 2) {
    return <svg className="sparkline" viewBox={`0 0 ${W} ${H}`} aria-hidden />;
  }
  const pts = thin(samples, MAX_POINTS);
  const xs = pts.map((p) => p.age);
  const ys = pts.map((p) => p.S);
  const x0 = xs[0]!;
  const x1 = xs[xs.length - 1]!;
  const yMin = Math.min(...ys, 0);
  const yMax = Math.max(...ys, 1);
  const sx = (x: number) => PAD + ((x - x0) / Math.max(1e-9, x1 - x0)) * (W - 2 * PAD);
  const sy = (y: number) =>
    H - PAD - ((y - yMin) / Math.max(1e-9, yMax - yMin)) * (H - 2 * PAD);

  const line = pts.map((p) => `${sx(p.age).toFixed(1)},${sy(p.S).toFixed(1)}`).join(' ');
  const zeroY = sy(0);

  return (
    <svg
      className="sparkline"
      viewBox={`0 0 ${W} ${H}`}
      preserveAspectRatio="none"
      role="img"
      aria-label="Net cash over time"
    >
      {yMin < 0 && (
        <line className="spark-zero" x1={PAD} y1={zeroY} x2={W - PAD} y2={zeroY} />
      )}
      <polyline className="spark-line" points={line} fill="none" />
    </svg>
  );
}
